<template>
  <div class="row">
    <div class="col">
      <h3 class="global-settings-title mb-4">Global Settings</h3>
      <div v-if="version < 3 && ($store.getters.isSuperAdmin) && false"
           class="settings-button d-inline-block mb-2"
           @click="$emit('convertToFile')">
        You won't be able to duplicate the vform in vSTAGE afterwards, be careful!<br>
        {{ $t('convertToNewVersion') }}
      </div>
      <div class="font-selector mt-1">
        <h3 class="">Font</h3>
        <font-selector
            v-if="form.formSettings && organizationId"
            :initial-selected-font="form.formSettings.font"
            :use-font-assets="true"
            :organization-id="organizationId"
            @change="setFontType"
        />
        <h3 class="mt-4">Font Size</h3>
        <slider :default-value="0.95" :initial-value="validFontSize"
                :interval="0.05" :max="1.4" :min="0.7"
                @change="(val) => { setFontSize(val); }"/>
        <label
            :for="'fontAutoSize' + $vnode.key"
            class="container d-inline-block mt-3"
            style="padding-left: 5px !important"
        >
          <input
              :id="'fontAutoSize' + $vnode.key"
              v-model="form.formSettings.fontAutoSize"
              type="checkbox"
          >
          <span class="checkmark"/>
          <div class="ml-4">{{ $t("vform.fontAutoSize") }}</div>
        </label>
      </div>
      <h3 class="mt-3">{{ $t('ThemeColor') }}</h3>
      <div class="d-inline-flex">
        <color-picker-and-field
            :field-background-color="form.formSettings.themeColor"
            @saveColor="(color) => {setItemColor('themeColor', color)}"
            @unsetColor="setItemColor('themeColor', null)"
        />
      </div>


      <h3 class="mt-3">Logo</h3>
      <div class="logo" @click="showSelect = true">
        <preview v-if="form.formSettings && form.formSettings.logoAssetId"
                 :asset-or-project-id="form.formSettings ? form.formSettings.logoAssetId : null"
                 :class="['small-thumbnail mb-1', 'default-imageDix']"
                 :preview-id="form.formSettings ? form.formSettings.logoAssetId : null"
                 :preview-uri="$store.getters['getMediaPreviewUri'](form.formSettings ? form.formSettings.logoAssetId : null)"
                 :removable="false"
                 :type="'image'"
        />

        <div v-if="!form.formSettings || !form.formSettings.logoAssetId" class="vform-alignment-button"
             @click="showSelect = true;">
          <icon size="1" type="folder"/>
        </div>
      </div>

      <popup
          v-if="showSelect"
          :style="{'z-index': 1000}"
          @close="() => {showSelect = false;}"
      >
        <div v-if="showSelect" slot="popupMainContent" class="w-100">
          <div class="col-12 col-md-6">
            <content-display
                :hide-upper-name="true"
                :show-preview="true"
                :value="form.formSettings.logoAssetId"
                class="bg-dark"
                list-name="generalList"
                type="media"
            />
            <span v-if="form.formSettings.logoAssetId" @click="() => {setLogo(null);}">
                <icon :size="'1.5'" type="trash"/>
              </span>
          </div>
          <content-list
              :list-name="'vformImages3'"
              :media-category="3"
              :organization-ids="[organizationId]"
              :show-preview="true"
              :thumbnail-view="true"
              class="col-12 col-md-12 mt-1"
              type="media"
              @save="setLogo"
          />
        </div>
      </popup>

      <div class="w-100 mb-4"/>
      <label class="vform-editor-label section mt-1">{{ $t("transition") }}</label>
      <select v-model="form.formSettings.slideTransition" class="custom-select darker">
        <option value="none">None</option>
        <option value="fade">Fade</option>
        <option value="zoom">Zoom</option>
      </select>
    </div>
    <label
        :for="'kioskmoder' + $vnode.key"
        class="container d-inline-block mt-3 ml-3"
        style="padding-left: 5px !important"
    >
      <input
          :id="'kioskmoder' + $vnode.key"
          v-model="form.alwaysKioskMode"
          type="checkbox"
      >
      <span class="checkmark"/>
      <div class="ml-4">{{ $t("alwaysKioskMode") }}</div>
    </label>
    <div class="ml-3 mr-3 mt-2">
      <div
          class="pl-3 pr-3 mt-2 settings-button clickable d-inline-block"
          @click="showBottomBarConfig = true">
        {{ $t("vform.configureBottomBar") }}
      </div>
    </div>
    <bottom-bar-configurator
        v-if="showBottomBarConfig"
        :form-settings="form.formSettings"
        @close="showBottomBarConfig = false"
    />
    <div class="ml-3 mr-3">
      <div
          class="pl-3 pr-3 mt-2 settings-button clickable d-inline-block"
          @click="$emit('addNextButtonToAllSteps')">
        {{ $t("addNextButtonForAllSteps") }}
      </div>
      <br>
    </div>
    <div v-if="vSTAGEContext" class="d-inline-block mt-4 ml-3">
      <screen-size-selector
          class="vform-screen-size-selector"
          @setOrientation="setScreenOrientation"
          @setSize="setScreenSize"
      />
    </div>
    <div v-if="vSTAGEContext" class="mt-4 ml-3">
      <language-selector
          :use-plain-language="true"
          :value="language"
          class="mr-2"
          open-direction="top"
          @update="setLanguage"
      />
    </div>
    <div v-if="form.languages && form.languages.filter(l => l !== 'Unknown').length" class="mt-4 ml-3 mr-3">
      <label class="vform-editor-label section">{{ $t('vform.manageLanguages') }}</label>
      <div
          v-for="lang in form.languages.filter(l => l !== 'Unknown')"
          :key="lang"
          class="d-flex align-items-center justify-content-between mt-1 language-manage-row"
      >
        <span class="vform-editor-body">{{ lang }}</span>
        <icon
            size="0.9"
            type="trash"
            class="clickable ml-2"
            @click.native="langToDelete = lang"
        />
      </div>
    </div>
    <popup v-if="langToDelete" @close="langToDelete = null">
      <div slot="popupMainContent" class="mt-4 col">
        <p class="vform-editor-body">{{ $t('vform.confirmDeleteLanguage', { lang: langToDelete }) }}</p>
        <div class="d-flex mt-3">
          <div class="settings-button mr-2 clickable" @click="langToDelete = null">{{ $t('cancel') }}</div>
          <div class="settings-button switched-colors clickable" @click="doDeleteLanguage">{{ $t('delete') }}</div>
        </div>
      </div>
    </popup>
  </div>
</template>


<script>

import LanguageSelector from "@/components/forms/LanguageSelector";
import ScreenSizeSelector from "@/components/vForm/viewer/ScreenSizeSelector";
import ContentList from "@/components/widgets/editors/ContentList";
import ContentDisplay from "@/components/widgets/editors/ContentDisplay";
import Popup from "@/components/Popup";
import Icon from "@/components/Icon";
import Preview from "@/components/preview/Preview";
import Slider from "@/components/widgets/editors/Slider";
import {fontSizeForSlider} from './formSettingsValues';
import FontSelector from "../FontSelector";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import BottomBarConfigurator from "@/components/vForm/BottomBarConfigurator.vue";

export default {
  name: "vFormGlobalSettings",
  components: {
    BottomBarConfigurator,
    ColorPickerAndField,
    LanguageSelector,
    ScreenSizeSelector,
    Popup,
    ContentList,
    ContentDisplay,
    Icon,
    Preview,
    Slider,
    FontSelector
  },

  props: {
    form: {type: Object, required: true},
    logId: {type: String, default: ""},
    language: {type: String, default: ""},
    vSTAGEContext: {type: Boolean, default: false},
    ccLightContext: {type: Boolean, default: false},
    organizationId: {type: String, default: ""},
    version: {type: Number, default: 0}
  },
  data() {
    return {
      showSelect: false,
      showBottomBarConfig: false,
      langToDelete: null,
      formSettings: {
        fontSize: "0.95",
        themeColor: '',
        logoAssetId: '',
        slideTransition: 'zoom',
        font: {name: 'Inter', id: 'Inter', systemFont: true},
        alwaysHideBottomBar: false
      },
    };
  },
  computed: {
    validFontSize() {
      return fontSizeForSlider(this.form.formSettings && this.form.formSettings.fontSize);
    }
  },
  watch: {
    form() {
      this.initFormSettings()
    },
    showSelect(val) {
      this.$emit('innerPopupActive', val);
    },
    showBottomBarConfig(val) {
      this.$emit('innerPopupActive', val);
    },
    langToDelete(val) {
      this.$emit('innerPopupActive', !!val);
    }
  },
  beforeMount() {
    this.initFormSettings();
  },
  methods: {
    setFontType(font) {
      this.$set(this.form.formSettings, "font", font);
      this.$emit('loadFont')
    },
    initFormSettings() {
      const {formSettings} = this.form;
      this.form.formSettings = formSettings ? formSettings : this.formSettings;
      if (this.form.alwaysKioskMode) {
        this.form.formSettings.alwaysKioskMode = this.form.alwaysKioskMode;
      }
      if (formSettings && formSettings.slideTransition) {
        this.form.formSettings.slideTransition = formSettings.slideTransition;
      }
      if (!this.form.formSettings.alwaysHideBottomBar) {
        this.$set(this.form.formSettings, 'alwaysHideBottomBar', false);
      }
      if (!this.form.formSettings.bottomBar) {
        this.$set(this.form.formSettings, 'bottomBar', {
          showLogo: true,
          showProjectName: true,
          showUserDisplay: true,
          showLanguageSelector: true,
          showSlideOutMenu: true,
          showHomeButton: true,
          showPrevButton: true,
          showNextButton: true,
        });
      }
      if(this.form.formSettings.fontAutoSize === undefined) {
        this.$set(this.form.formSettings, "fontAutoSize", false);
      }
    },
    setFontSize(size) {
      this.$set(this.form.formSettings, "fontSize", size);
    },
    setLanguage(lang) {
      this.$store.dispatch('updateSelectedFormLanguage', lang)
    },
    confirmDeleteLanguage(lang) {
      this.langToDelete = lang;
    },
    doDeleteLanguage() {
      this.$emit('deleteLanguage', this.langToDelete);
      this.langToDelete = null;
    },
    setScreenSize(size, customSize) {
      this.$emit("setScreenSize", size, customSize);
    },
    setScreenOrientation(orientation) {
      this.$emit("setScreenOrientation", orientation);
    },
    setItemColor(colorPickrId, color, closePickr = true) {
      if (closePickr) {
        this.colorPickrId = null;
      }
      this.$set(this.form.formSettings, colorPickrId, color);
      this.$emit('themeChanged');
    },
    setLogo(assetId) {
      this.form.formSettings.logoAssetId = assetId;
      this.showSelect = false;
      if (assetId) {
        this.$store.dispatch("loadMedia", {
          id: assetId,
        });
      }
      this.$emit('logoChanged');
    },
  }
}

</script>

<style scoped>
h2 {
  margin-bottom: 0;
}

h3.global-settings-title {
  font-size: 1.2rem;
}

.logo {
  width: 50px;
  cursor: pointer;
}

.language-manage-row {
  padding: 3px 0;
  border-bottom: 1px solid rgba(255,255,255,0.08);

  &:last-child {
    border-bottom: none;
  }
}
</style>
